import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { responsiveCard } from "../../utils/responsive";

export const cardStyle = recipe({
  base: {},
});

export const innerCardStyle = recipe({});

export const growStyle = recipe({
  base: {
    flexGrow: 1,
  },
  variants: {
    gap: {
      none: {},
      xs: {
        gap: theme.spacings.xs,
      },
      s: {
        gap: theme.spacings.s,
      },
      m: {
        gap: theme.spacings.m,
      },
      l: {
        gap: theme.spacings.l,
      },
    },
  },
});

export const headerStyle = recipe({
  base: {},
  variants: {
    direction: {
      horizontal: {
        flexDirection: "column",
        alignItems: "flex-start",
        ...responsiveCard({
          400: {
            flexDirection: "row",
            alignItems: "center",
          },
        }),
      },
      vertical: {
        flexDirection: "column",
      },
    },
  },
  defaultVariants: {
    direction: "horizontal",
  },
});

export const cardTitleStyle = recipe({
  base: {
    lineHeight: 1.2,
  },
});

export const cardSubtitleStyle = recipe({
  base: {
    lineHeight: 1.2,
  },
});
